module.exports = __webpack_public_path__ + "42c6134ef1f0a345a017a8c04ba9ea42.svg";